import { fixedAssets } from 'src/containers/PreCache'
import styled from 'styled-components'

export const PageStyle = styled.div`
  background-image: url('${fixedAssets.boothBg}');
  background-size: cover;
  padding-top: 30px; // 30px notice bar
  height: 100vh;
  overflow: scroll;

  // layout -> content -> grid-container OR infinite-scroll-container
  .page-layout {
    height: 100%;
    display: grid;
    grid-template-columns: minmax(280px, 25%) 1fr;
  }

  .page-content {
    backdrop-filter: blur(5px);
    background-color: rgba(255, 255, 255, 0.65);
    display: grid;
    grid-template-rows: 80px 1fr; // 80px header
    /* padding-right: 65px; // right navbar */

    .grid-container {
      display: grid;
      grid-gap: 60px;
      grid-template-columns: repeat(auto-fill, 170px);
      margin: 20px 70px;
      grid-auto-rows: max-content;
    }
    .soon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #569099;
      font-weight: 800;
    }

    // header
    .back-btn {
      background: #000;
      font-weight: bold;
      display: flex;
      align-items: center;
      text-decoration: none;
      padding: 20px 30px;
      .back-icon {
        cursor: pointer;
        display: flex;
        width: 30px;
        flex-direction: column;
        img,
        svg {
          transition: 100ms linear;
          height: 24px;
        }
        .icon-label {
          transition: 100ms linear;
          text-align: left;
          font-size: 1px;
          opacity: 0;
        }
        &:hover {
          img,
          svg {
            transform: scale(0.5);
          }
          .icon-label {
            font-size: 8px;
            opacity: 1;
          }
        }
      }
      span {
        font-size: 24px;
        margin-left: 1em;
        color: #F8C605;
      }
    }
  }

  .page-sidebar {
    color: #F8C605;
    font-size: 20px;
    padding: 0;
    position: relative;
    background-color: #F8C605;
    /* background-image: url('${fixedAssets.bannerBg}'); */
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .page-title {
      padding: 20px 30px;
      background: #000;
      width: 100%;
      h2 {
        text-align: center;
        font-weight: 600;
        font-size: 35px;
        margin: 0;
      }
    }
  }
  .card-thumbnail {
    display: block;
    cursor: pointer;
    position: relative;
    text-align: center;
    color: #525252;
    font-weight: 500;
    text-decoration: none;
    font-size: 16px;
    img {
      transition: 150ms ease-in;
    }

    &:hover {
      img {
        transform: scale(1.1);
      }
    }
  }
`
